import React from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import { CssTextField } from '../../components/TextField';
import { updateMealPlan } from '../../store/actions';
import { Formik } from 'formik';
import Header from '../../components/Header';

function UpdateMealPlanModalContent({ roomtypeId, dispatch, isLoading, setModal, colors, updationData }) {

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { sm: 400, xs: "90%" },
        bgcolor: colors.primary[400],
        outline: "none",
        boxShadow: 24,
        p: 2,
    };

    const initialValues = {
        roomtypeId: roomtypeId,
        id: updationData?._id,
        name: updationData?.name ?? "",
        rate: updationData?.rate ?? "",
        description: updationData?.description ?? "",
    };
    const handleFormSubmit = async (values) => {
        console.log(values);
        await dispatch(updateMealPlan(values));
        setModal(false);
    };

    return (
        <>
            <Box sx={modalStyle}>
                <>
                    <Header title="UPDATE MEAL PLAN" titleVariant="h4" />
                    <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                            <form onSubmit={handleSubmit}>

                                <Stack spacing={2}>
                                    <CssTextField
                                        required
                                        fullWidth
                                        size="small"
                                        type="text"
                                        label="Name"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.name}
                                        name="name"
                                        error={!!touched.name && !!errors.name}
                                        helperText={touched.name && errors.name}
                                    />
                                    <CssTextField
                                        required
                                        fullWidth
                                        size="small"
                                        type="number"
                                        label="Rate"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.rate}
                                        name="rate"
                                        error={!!touched.rate && !!errors.rate}
                                        helperText={touched.rate && errors.rate}
                                        inputProps={{ min: 0 }}
                                    />
                                    <CssTextField
                                        fullWidth
                                        size="small"
                                        type="text"
                                        label="Description"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.description}
                                        name="description"
                                        error={!!touched.description && !!errors.description}
                                        helperText={touched.description && errors.description}
                                    />
                                    <Button
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        color="secondary"
                                        variant="contained"
                                        sx={{ fontSize: "15px" }}
                                    >
                                        {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Submit</b>}
                                    </Button>
                                </Stack>
                            </form>
                        )}
                    </Formik>
                </>
            </Box>
        </>
    )
}

export default UpdateMealPlanModalContent